<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>新增分隊</h3>
          <hr />
        </div>
      </div>
      <div class="container">
        <form @submit="onInsertBtnClick" class="row">
          <div class="col-sm-5 offset-md-6 word_left col-md-offset-4">
            <div class="col-sm-4 fontSize16 selectstyle">分隊名稱:*</div>
            <input
              v-model="group.name"
              type="text"
              required=""
              class="inputstyle col-md-6 fontSize16"
              placeholder=""
            />
          </div>
          <div
            class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle"
          >
            <div class="col-sm-4 fontSize16 selectstyle">聯絡人(或隊長:)*</div>
            <select
              v-model="group.manager_id"
              required=""
              class="inputstyle col-md-6 fontSize16"
              name=""
            >
              <option value="">請選擇</option>
              <option v-for="driver in selected_driver_list" :value="driver.id">
                {{ driver.call_number }}
              </option>
            </select>
          </div>
          <div
            class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle"
          >
            <div class="col-sm-4 fontSize16 selectstyle">聯絡電話:</div>
            <div class="col-sm-4 fontSize16 selectstyle">{{ phone }}</div>
          </div>
          <div
            class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle"
          >
            <div class="col-sm-4 fontSize16 selectstyle">聯絡電話2:</div>
            <input
              type="text"
              v-model="group.alt_telephone"
              class="inputstyle col-md-6 fontSize16"
              placeholder=""
            />
          </div>
          <div
            class="col-sm-5 offset-md-6 word_left col-md-offset-4 selectstyle"
          >
            <div class="col-sm-5 fontSize16 selectstyle">
              目前分隊中司機呼號:
            </div>
            <textarea
              disabled
              rows="5"
              class="inputstyle col-md-7 fontSize16"
              required=""
              >{{ selected_driver }}</textarea
            >
          </div>
          <div class="col-sm-5 offset-md-6 word_left col-md-offset-4">
            <div class="col-sm-4 fontSize16 selectstyle">沒有分隊之司機</div>
            <label>
              <span class="checkbox_inline">
                <input
                  @click="onAllSelectedClick"
                  v-model="all_selected"
                  type="checkbox"
                  class="flat"
                />
                <span class="fontSize14 textmarginleft">全選</span>
              </span>
            </label>
          </div>
          <div
            class="col-sm-5 offset-md-6 word_left col-md-offset-4 inputstyle black_block textareastyle"
          >
            <label v-for="driver in driver_list">
              <span class="checkbox_inline">
                <input
                  v-model="selected_driver_list"
                  :value="driver"
                  type="checkbox"
                  class="flat"
                />
                <span class="fontSize14 textmarginleft">
                  {{ driver.call_number }}
                </span>
              </span>
            </label>
          </div>
          <div
            class="col-sm-1 offset-md-6 word_left col-md-offset-8 textareastyle"
          >
            <button type="submit" class="mybtnstyle btn-dark">新增分隊</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import Group from '../../assets/js/libs/Group'
var group = new Group()

export default {
  name: 'GroupList',
  data() {
    return {
      driver_list: [],
      group: {
        name: '',
        manager_id: null,
        alt_telephone: null,
      },
      selected_driver_list: [],
      all_selected: false,
    }
  },
  methods: {
    onAllSelectedClick() {
      this.all_selected = !this.all_selected
      if (this.all_selected) this.selected_driver_list = this.driver_list
      else this.selected_driver_list = []
    },
    onInsertBtnClick(event) {
      event.preventDefault()
      if (this.selected_driver_list.length == 0) {
        alert('未勾選司機')
        return
      }
      if (confirm('確定送出?')) {
        var data = {
          drivers: this.selected_driver_list,
          manager_id: this.group.manager_id,
          name: this.group.name,
          alt_telephone: this.group.alt_telephone,
        }
        group
          .create(data)
          .then((res) => {
            this.$router.replace('/main/groupList')
          })
          .catch((err) => {
            if (err.data.error.type == 'unique') alert(err.data.error.message)
            else console.log(err)
            console.log(e)
          })
      }
    },
  },
  computed: {
    selected_driver() {
      this.all_selected =
        this.selected_driver_list.length == this.driver_list.length

      this.selected_driver_list.sort((a, b) => {
        return a.call_number - b.call_number
      })

      return this.selected_driver_list.reduce((accumulator, currentValue) => {
        return `${currentValue.call_number},${accumulator}`
      }, '')
    },
    phone() {
      var phone = null
      this.selected_driver_list.forEach((driver) => {
        if (this.group.manager_id == driver.id) phone = driver.account
      })
      return phone
    },
  },
  mounted() {
    group
      .getSingleDrivers()
      .then((res) => {
        this.driver_list = res.list
        console.log(res.list)
      })
      .catch((err) => {
        console.log(err)
      })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/group/AddGroup.vue